module.exports = __webpack_public_path__ + "static/media/hero.e7276405.jpg";